import VueI18n from 'vue-i18n'
import Vue from 'vue'
import zh from './locales/zh-CN.js'
import en from './locales/en-US.js'
import ft from './locales/ft.js'
import th from './locales/th-TH.js'
Vue.use(VueI18n);

const saved = localStorage.getItem('language')
// 兼容旧值：繁体归到中文简体；默认泰语
const locale = !saved || saved === 'ft' ? (saved === 'ft' ? 'zh' : 'th') : saved
localStorage.setItem('language', locale)
// 接口 lang 头：与 locale 同步，默认 th
const langApiMap = { zh: 'zh_cn', th: 'th', en: 'en' }
if (!localStorage.getItem('languageTow') || saved === 'ft' || !saved) {
	localStorage.setItem('languageTow', langApiMap[locale] || 'th')
}

const i18n = new VueI18n({
	locale,
	fallbackLocale: 'th',
	silentFallbackWarn: true,
	messages: {
		th: {
			...th
		},
		zh: {
			...zh
		},
		en: {
			...en
		},
		// 保留繁体包以免旧缓存报错，弹窗不再展示
		ft: {
			...ft
		},
	}
})
export default i18n;
